import React from "react";
import "./SimpleNumberCard.scss";
import { Typography } from "@design-system/components/Typography/Typography";

export type SimpleNumberCardProps = {
  value: number;
  labelForSingle: string;
  labelForMultiple: string;
};

export const SimpleNumberCard: React.FC<SimpleNumberCardProps> = ({ value, labelForSingle, labelForMultiple }) => {
  return (
    <div className="simple-number-card">
      <span className="number-value">{value}</span>
      <Typography intrinsic="h3" color="primary" className="number-label">{value === 1 ? labelForSingle : labelForMultiple}</Typography>
    </div>
  );
};
